/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SettingManagementEditSettingResponse } from './SettingManagementEditSettingResponse';

export type SettingManagementEditSettingResponseApiRespoonse = {
    data?: SettingManagementEditSettingResponse;
    status?: SettingManagementEditSettingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace SettingManagementEditSettingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

